export default 'https://goliaths-revenge-api.herokuapp.com'

// export default 'http://localhost:5000';
